<template>
    <div class="container">
        <div class="bar" :style="{
                    'width':`${(face_analysis.found_face_frames/face_analysis.total_frames)*100}%`,
                    'background-color':attendance_strength_color}"
                ></div>
        <div class="faculty-area">
            <div class="faculty-stream" :class="{novideo:novideo}">
                <video :src-object.prop.camel="remoteStream" autoplay ></video>
            </div>
        </div>
        <div class="chat-box" :class="{video_minimised_chat:video_minimised}">
            <chat-box :roomId="roomId" />
        </div>
        <div class="student-area" :class="{minimised:video_minimised}" >
            <div class="maximise-control"  >
                <div class="minimise-btn" :class="{disabled_btn:video_minimised}" @click="video_minimised=!video_minimised" ><i class="far fa-window-minimize"></i></div>
                <div class="maximise-btn" :class="{disabled_btn:!video_minimised}" @click="video_minimised=!video_minimised"><i class="far fa-square"></i></div>
            </div>
            <div class="student-stream"  @click="video_minimised=!video_minimised">
                <canvas id="canvas" ></canvas>
                <video id="video" :src-object.prop.camel="localStream" autoplay ></video>
                
            </div>
        </div>
    </div>
</template>
<script>
import ChatBox from '../components/ChatBox.vue'
import {
    get_offer,
    upload_participant,
    add_faculty_ice_candidates_listener,
    upload_student_ice_candidate,
    listen_video_mute_event,
    listen_audio_mute_event
} from '../services/video_calling'
export default {
    data(){
        return{
            video_minimised:false,
            face_analysis:{
                total_frames:0,
                found_face_frames:0
            },
            roomId:"",
            conversation:[],
            doubt_text:"",
            novideo:true,
            student:{},
            student_peer:null,
            remoteStream: new MediaStream(),
            localStream:null,
            remote_video_track:null,
            remote_audio_track:null,
            lecture:{
                facultyName:"Anish",
                facultyId:"MRn5Kga60tUwKGrrfsyKerwbcJ03",
                subject:"Maths",
                startTime:"9:00",
                endTime:"9:50",
                batch:"B1",
                year:1
            },
            configuration : {
                iceServers: [
                    {
                    urls: [
                        'stun:stun1.l.google.com:19302',
                        'stun:stun2.l.google.com:19302',
                    ],
                    },
                ],
                iceCandidatePoolSize: 3,
            },
        }
    },
    computed: {
        attendance_strength(){
            return this.face_analysis.found_face_frames*100/this.face_analysis.total_frames
        },
        attendance_strength_color(){
            return this.attendance_strength>34 ? 'green':'red'
        }
    },
    components:{
        'chat-box':ChatBox
    },
    async created() {
        this.roomId = this.lecture.facultyId
        this.student = JSON.parse(localStorage.getItem('user'))
        await this.open_webcam()
        
        this.student_peer = await new RTCPeerConnection(this.configuration)
        await this.add_track()
        let offer = await get_offer(this.lecture.facultyId)
        console.log("offer")
        this.render_canvas()
        await this.add_ice_candidates_listener()
        await this.add_track_listener()

        await this.student_peer.setRemoteDescription( new RTCSessionDescription(offer))
        let answer = await this.student_peer.createAnswer()
        await this.student_peer.setLocalDescription(answer)
        await upload_participant(this.lecture.facultyId,this.student,answer)
        await add_faculty_ice_candidates_listener(this.lecture.facultyId,this.add_faculty_ice_candidates)

        
    },
    methods: {
        render_canvas(){
            let canvas = document.getElementById('canvas')
            let video = document.getElementById("video")
            canvas.height = video.offsetHeight
            canvas.width = video.offsetWidth
            let context = canvas.getContext('2d')
            context.strokeStyle = '#fff'
            context.lineWidth = 1
            let socket = io.connect('http://127.0.0.1:5000');
            let x=0,y=0,w=0,h=0
            setInterval(()=>{
                context.drawImage(video,0,0,canvas.width,canvas.height)
                context.strokeRect(x,y,w,h)
                // console.log("Image data",data)
            },100)
            socket.on('connect',()=>{
                alert("connected")
                setInterval(()=>{
                    let data = canvas.toDataURL('image/png');
                    this.face_analysis.total_frames++
                    socket.emit("image",data)
                },500)

                socket.on("message",ev=>{
                    let faces = JSON.parse(ev)
                    if (faces.length == 0){
                        x=0,y=0,w=0,h=0
                    }
                    else this.face_analysis.found_face_frames++
                    
                    faces.forEach(face => {
                        x=face.x;
                        y=face.y;
                        w=face.w;
                        h=face.h;

                        console.log("updated")
                    });
                })
            })
        },
        toggle_host_video(ismute){
            console.log("toggliong host video",ismute)
            if (ismute){
                this.remote_video_track = this.remoteStream.getVideoTracks()[0]
                this.remoteStream.removeTrack(this.remote_video_track)
                this.novideo = true
            }else{
                if(this.remote_video_track) this.remoteStream.addTrack(this.remote_video_track)
                this.novideo=false
            }
        },
        toggle_host_audio(ismute){
            console.log("toggliong host video",ismute)
            if (ismute){
                this.remoteStream.getTracks().forEach(track=>{
                    if(track.kind === "audio") track.stop()
                    
                })
            }
        },
        async add_faculty_ice_candidates(candidate){
            console.log('Adding remote ice candidate');
            await this.student_peer.addIceCandidate(new RTCIceCandidate(candidate));
        },
        async add_track_listener() {
            listen_video_mute_event(this.lecture.facultyId,this.toggle_host_video)
            listen_audio_mute_event(this.lecture.facultyId,this.toggle_host_audio)
            this.student_peer.addEventListener('track', event => {
                console.log('Got remote track:');
                event.streams[0].getTracks().forEach(track => {
                    track.addEventListener('ended',()=>{
                        console.log("Ended")
                    })
                    console.log('Add a track to the remoteStream:',track);                   
                    this.remoteStream.addTrack(track);
                });
                this.novideo = false
            });
        },
        async add_ice_candidates_listener(){
            this.student_peer.addEventListener('icecandidate',async event=>{
                if (!event.candidate) {
                    console.log('Got final candidate!');
                    return;
                }
                console.log('Got candidate: ');
                await upload_student_ice_candidate(this.lecture.facultyId,this.student.uid,event.candidate.toJSON())
            })
        },
        async add_track(){
            this.localStream.getTracks().forEach(track =>{
                console.log("Adding track to localstream")
                this.student_peer.addTrack(track,this.localStream)
            })
        },
        async open_webcam(){
            this.localStream = await navigator.mediaDevices.getUserMedia({video:true,audio:true})
        },

        close_webcam(){
            this.localStream.getTracks().forEach(track=>{track.stop()})
            this.localStream = null
        }
    }
}
</script>
<style scoped>
.container{
    height: 100%;
    padding:.5rem;
    position: relative;
    overflow-y: hidden;
}
.faculty-area{
    width: 100%;
    height:100% ;
    background-color: #707070;
    position: relative;
}
.faculty-stream{
    height: 100%;
    width: 100%;
}
.novideo{background-color: #707070 !important;}
.novideo video{display:none}

.faculty-stream video{
    height: 100%;
    width: 100%;
    object-fit: fill;
}
.student-area{
    position: absolute;
    bottom:.5rem;
    right:.5rem;
    /* margin: 0 .5rem; */
    width:30rem;
    max-width:calc(100% - 1rem);
    height:20rem;
    background-color: #ececec;
    transition: .3s all;
}

.student-stream{
    height: 100%;
    width: 100%;
    position: relative;
}

.minimised{
    transform-origin: 0 0 ;
    height:1.5rem;
    overflow: hidden;
}
.maximise-control{
    position: absolute;
    z-index: 999999;
    width: 100%;
    right:0;
    height:1.5rem;
    text-align: right;
    background-color: #0000006c;
    color:#ececec;
    font-size: 1.2rem;
    padding: 0 1rem;
}
.maximise-btn,.minimise-btn{
    display: inline-block;
    padding: 0 .5rem;
}
.maximise-btn:hover,.minimise-btn:hover{
    cursor: pointer;
}
.maximise-btn i,.minimise-btn i{
    font-size: 1.2rem;
    color:#ffffff
}
.disabled_btn i{
    color:#c3c2c2 !important;
}
.disabled_btn:hover{
    cursor: not-allowed;
}
.student-stream video{
    visibility: hidden;
}
.bar{
    position: absolute;
    height:5px;
    top:0;
    background-color: green;
    transition: .3s width;
    max-width: calc(100% - 1rem);
}
#canvas{
    position: absolute;
    /* z-index: 999999999999; */
}
.student-stream video{
    height: 100%;
    width: 100%;
    object-fit: fill;
}
.chat-box{
    position: absolute;
    top:.5rem;
    right:.5rem;
    z-index: 99999;
    height: calc(100% - 21rem);
    width:30rem ;
    max-width:calc(100% - 1rem);
    transition: .3s all;
}
.video_minimised_chat{
    height:calc(100% - 2.5rem)
}

@media only screen and (max-width: 350px ) {
    .chat-box{
        width: 100%;
        right:.5rem;
    }
    .student-area{
        width: 100%;
    }
}

</style>


// WEBPACK FOOTER //
// src/views/AttendClass.vue